import React from 'react';

import {defaultTheme} from '@ibibo/build-theme';

import * as S from './CancelRightBlock.styles';

import IconSelector from '@ibibo/icon-selector';

interface Props {
  hotelDetails: {
    hotelName: string;
    image: string;
    roomType: string;
    rooms: string;
  };
  breakupSummary?: {
    paid_amount: number;
    refund_amount: number;
    cancelcharges: number;
  };
  refundBreakup?: Array<object>;
}

const CancelRightBlock = ({hotelDetails, breakupSummary, refundBreakup=[]}: Props) => {
  const {hotelName, image, roomType, rooms} = hotelDetails;
  const {paid_amount, refund_amount, cancelcharges} = breakupSummary || {};
    return(
        <S.CancelRightMainWrap>
            <S.CancelRightBlockHeadText>Cancellation Summary</S.CancelRightBlockHeadText>
            <S.RightBlockInnerWrap>
                <S.BlockHtlImg src={image} alt="hotel"></S.BlockHtlImg>
                <S.BlockHtlRoomInfoWrap>
                    <S.BlockHtlNameText>{hotelName}</S.BlockHtlNameText>
                    <S.BlockHtlRoomTypeWrap>
                        <S.BlockRoomTypeImg>
                            <IconSelector iconKey='roomsize' />
                        </S.BlockRoomTypeImg>
                        <S.BlockRoomTypeText>{roomType} x {rooms}</S.BlockRoomTypeText>
                    </S.BlockHtlRoomTypeWrap>
                </S.BlockHtlRoomInfoWrap>
                <S.BlockPriceInfoWrap>
                  {(typeof paid_amount !== 'undefined' && <S.PriceBreakUpInnerWrap>
                  <S.PriceBreakUpTextWrap>
                    <S.PrcieBreakUpText>Total Paid</S.PrcieBreakUpText>
                    <S.PrcieBreakUpAmount><IconSelector iconKey='rupee' props={{width:'1rem', height:'1rem', fill: defaultTheme.colors.grey.base}}/>{paid_amount.toLocaleString('en-IN')}</S.PrcieBreakUpAmount>
                  </S.PriceBreakUpTextWrap>
                  </S.PriceBreakUpInnerWrap>) || null}
                  {(typeof cancelcharges !== 'undefined' && <S.PriceBreakUpInnerWrap>
                    <S.PriceBreakUpTextWrap>
                      <S.PrcieBreakUpText>Cancellation Charges</S.PrcieBreakUpText>
                      <S.PrcieBreakUpAmount><IconSelector iconKey='rupee' props={{width:'1rem', height:'1rem', fill: defaultTheme.colors.grey.base}}/>{cancelcharges.toLocaleString('en-IN')}</S.PrcieBreakUpAmount>
                    </S.PriceBreakUpTextWrap>
                  </S.PriceBreakUpInnerWrap>) || null}
                  {(typeof refund_amount !== 'undefined' && <S.PriceBreakUpInnerWrap>
                    <S.PriceBreakUpTextWrap>
                      <S.PrcieRefundText>Total Refund</S.PrcieRefundText>
                      <S.PrcieRefundAmount><IconSelector iconKey='rupee' props={{width:'1.5rem', height:'1.5rem', fill: defaultTheme.colors.green.base}}/>{refund_amount.toLocaleString('en-IN')}</S.PrcieRefundAmount>
                    </S.PriceBreakUpTextWrap>
                  </S.PriceBreakUpInnerWrap>) || null}

                  {refundBreakup.map(item => <S.PriceBreakUpInnerWrap key={item.id} fs={item.fs} fw={item.fw} color={item.cc}>
                    <S.PriceBreakUpTextWrap>
                      <S.PrcieBreakUpText>{item.k}</S.PrcieBreakUpText>
                      <S.PrcieBreakUpAmount>{item.s}{item.c}{item.v}</S.PrcieBreakUpAmount>
                    </S.PriceBreakUpTextWrap>
                    {(item.st && <S.PriceBreakUpSubText>
                      <S.PrcieBreakUpSubAmount>({item.st})</S.PrcieBreakUpSubAmount>
                    </S.PriceBreakUpSubText>) || null}
                  </S.PriceBreakUpInnerWrap>)}
                </S.BlockPriceInfoWrap>
                {/* <S.RefundBtnWrap>
                    <S.RefundBtn>SELECT REFUND MODE</S.RefundBtn>
                </S.RefundBtnWrap> */}
            </S.RightBlockInnerWrap>
        </S.CancelRightMainWrap>
    );
}

export default CancelRightBlock;